import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useMemo, useEffect } from 'react';
import styled from 'styled-components';
import { Button, message } from 'antd';
import { _deleteLayerBySiteID } from './../../../../shared/httpservice/apis/layers';
import { getFloorShapeAction, fetchSiteLayers } from '../../../../store/EditoreSlice';
import { useSelector, useDispatch } from 'react-redux';
import { LayerItem } from './LayerItem';
import Input from '../../../../components/common/Input';
import Icon from '../../../../components/common/Icon';
const SearchContainer = styled.div `
  border-bottom: 1px solid rgba(0, 0, 0, 0.07);
  padding: 8px;
`;
const CreateButton = styled(Button) `
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 12px;
  font-size: 14px;
  height: auto;
  transition: background-color 0.2s ease;
  cursor: pointer;
  border-radius: 10px;
  background-color: #ffffff;
  color: ${({ theme }) => theme.colors.dark};
  border: 2px solid transparent;
  word-break: break-word;
  white-space: initial;
  text-align: left;
  strong {
    color: ${({ theme }) => theme.colors.primary};
    font-weight: 500;
  }
  span:not(.bc-btn-icon) {
    display: flex;
    flex-wrap: wrap;
    gap: 2px;
  }
`;
const LayerList = styled.div `
  max-height: 300px;
  overflow-y: auto;
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
export const LayerManager = ({ layerData, createLayer, selectedLayer, setSelectedLayer, hideLayer, unHideLayer, floorLayerData, floorData, }) => {
    const [layers, setLayers] = useState([
    // { name: "Sample 1", visible: true },
    ]);
    if (floorData && floorData?.length) {
    }
    const siteId = useSelector((state) => state?.site?.checkSite?.response?.data?.siteId);
    const dispatch = useDispatch();
    useEffect(() => {
        if (layerData?.length) {
            setLayers(layerData.map((layer) => ({
                name: layer,
                visible: true,
            })));
        }
    }, [layerData]);
    const [inputValue, setInputValue] = useState('');
    const filteredLayers = useMemo(() => {
        if (!inputValue)
            return layers;
        const searchTerm = inputValue.toLowerCase();
        return layers.filter((layer) => layer.name.toLowerCase().includes(searchTerm));
    }, [layers, inputValue]);
    const handleSearch = (value) => {
        setInputValue(value);
    };
    const handleAddLayer = () => {
        if (inputValue && !layers.find((layer) => layer.name.toLowerCase() === inputValue.toLowerCase())) {
            createLayer(inputValue);
            //   setLayers([...layers, { name: inputValue, visible: true }]);
            setInputValue('');
        }
    };
    const toggleLayerVisibility = (layerName) => {
        const find = layers.find((layer) => layer.name === layerName);
        if (find) {
            const visibility = !find.visible;
            setLayers(layers.map((layer) => (layer.name === layerName ? { ...layer, visible: visibility } : layer)));
            if (visibility) {
                unHideLayer(layerName);
            }
            else {
                hideLayer(layerName);
            }
        }
    };
    const deleteLayer = async (layerName) => {
        const find = floorLayerData?.find((layer) => layer?.name === layerName);
        if (find && find?.layerId && siteId && floorData && floorData?.length) {
            try {
                await _deleteLayerBySiteID(siteId, find?.layerId).then(() => {
                    dispatch(fetchSiteLayers(siteId));
                    dispatch(getFloorShapeAction({ siteId, floorId: floorData[0] }));
                });
            }
            catch (error) {
                message.error('Layer deletion failed');
            }
        }
    };
    const showCreateButton = inputValue && !layers.find((layer) => layer.name.toLowerCase() === inputValue.toLowerCase());
    return (_jsxs(_Fragment, { children: [_jsx(SearchContainer, { children: _jsx(Input, { variant: "filled", value: inputValue, onChange: (e) => handleSearch(e.target.value), placeholder: "Search or create a layer", allowClear: true }) }), filteredLayers.length > 0 ? (_jsx(LayerList, { children: filteredLayers.map((layer) => (_jsx(LayerItem, { name: layer.name, visible: layer.visible, onToggleVisibility: toggleLayerVisibility, deleteLayer: deleteLayer, onClick: () => setSelectedLayer(layer.name), selected: layer.name === selectedLayer }, layer.name))) })) : null, showCreateButton && (_jsx(CreateButton, { type: "text", onClick: handleAddLayer, icon: _jsx(Icon, { icon: "layers-two-02", size: 16 }), children: _jsxs("span", { children: ["Create layer ", _jsxs("strong", { children: ["\"", inputValue, "\""] })] }) }))] }));
};
